import React, { useContext, useEffect, useState } from 'react';

import { EtapesSaisieContext } from '../../App';


export const BarreProgression: React.FC = () => {
  const { etapesSaisie, directToEtapeSaisie, indexRubriqueSaisie, indexEtapeDansRubrique } = useContext(EtapesSaisieContext);
  const [etapesBarre, setEtapesBarre] = useState<JSX.Element[]>([]);
  const handleClick = (numRubrique: number): void => {
    if (indexRubriqueSaisie !== numRubrique) {
      directToEtapeSaisie(numRubrique, 0);
    }
  }

  useEffect(() => {
    const _etapesBarre = [];
    let index = -1;
    for (let i = 0; i < etapesSaisie.length; i += 1) {
      if (!etapesSaisie[i].vide) {
        index += 1;
        _etapesBarre.push(<div key={index}>
          {index !== 0 &&
            <span
              className={indexRubriqueSaisie >= i
                ? 'ligne fait' : 'ligne'}
                key={`span_ligne_${index}`}
            >
            </span>
          }

          <span className={indexRubriqueSaisie >= i ? 'etape fait'
            : (indexRubriqueSaisie === i
              ? (index === 0 ? 'etape premiere actuelle' : 'etape actuelle')
              : (index === 0 ? 'etape premiere' : 'etape'))}
            onClick={(): void => handleClick(i)}
            key={`span_etape_${index}`}
          >
            {index + 1}
            <div
              className="desc"
              key={`div_desc_${index}`}
            >{etapesSaisie[i].nomRubrique}</div>
          </span>
        </div>);
      }
    }
    setEtapesBarre(_etapesBarre);
  }, [etapesSaisie, indexRubriqueSaisie, indexEtapeDansRubrique]);


  return (
    <div id="progression">
      {etapesBarre}
    </div>
  );
}
